import React from "react";
import Svg, { Path } from "react-native-svg";

const ShippingIcon = () => {
  return (
    <Svg
      width="50"
      height="50"
      viewBox="0 0 46 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M23.9307 35.8595L23.4653 36.7446L23.9307 35.8595C23.348 35.5532 22.652 35.5532 22.0693 35.8595L22.5347 36.7446L22.0693 35.8595L9.6335 42.3974L12.0085 28.5499C12.1198 27.9011 11.9047 27.2391 11.4333 26.7797L1.37255 16.9728L15.2762 14.9525C15.9276 14.8578 16.4908 14.4487 16.7821 13.8584L23 1.25955L29.2179 13.8584C29.5092 14.4487 30.0724 14.8578 30.7238 14.9525L44.6275 16.9728L34.5667 26.7797C34.0953 27.2391 33.8802 27.9011 33.9915 28.5499L36.3665 42.3974L23.9307 35.8595Z"
        stroke="black"
        stroke-opacity="0.5"
        stroke-width="2"
      />
    </Svg>
  );
};

export default ShippingIcon;
